import { TestAssignment } from '../../../api/admin';

export type AssignmentStatus =
  | 'Invited'
  | 'In Progress'
  | 'Completed'
  | 'Assessed';

export const ASSIGNMENT_STATUS_OPTIONS: Array<{
  value: AssignmentStatus;
  label: string;
}> = [
  { value: 'Invited', label: 'Invited' },
  { value: 'In Progress', label: 'In Progress' },
  { value: 'Completed', label: 'Completed' },
  { value: 'Assessed', label: 'Assessed' },
];

/**
 * Derives the lifecycle status of a test assignment. Mirrors the logic in
 * `TestStatusCell` so the status filter and the status pill stay consistent.
 */
export function getAssignmentStatus(
  assignment: Pick<
    TestAssignment,
    'startedAt' | 'finishedAt' | 'reviewedAt'
  >
): AssignmentStatus {
  if (assignment.reviewedAt) return 'Assessed';
  if (assignment.finishedAt) return 'Completed';
  if (assignment.startedAt) return 'In Progress';
  return 'Invited';
}
